// extracted by mini-css-extract-plugin
export default {"tooltip":"UiTooltip_tooltip_HTCpd","border":"UiTooltip_border_FfA4A","shadow":"UiTooltip_shadow_PfKud","text":"UiTooltip_text_B7ztg"};